import { render } from "./CampaignResultsPage.vue?vue&type=template&id=1341d8c5&lang=html"
import script from "./CampaignResultsPage.vue?vue&type=script&lang=js"
export * from "./CampaignResultsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__